import { Clock } from "lucide-react";
import type { BlogFrontmatter } from "@shared/blog";

import { formatArabicDate, readingTimeLabel } from "@/lib/blog/format";
import { ClusterChip } from "./ClusterChip";

const Dot = () => (
  <span aria-hidden="true" className="text-gray-300">
    ·
  </span>
);

/**
 * Post header outside the article card (UI-SPEC section 2 item 3): chip, h1, lede, then the byline
 * row «فريق يتفرج» (D-09) · published · updated (only when it differs) · reading time. Dates come
 * from the deterministic formatter, so SSR and hydration print the same string.
 */
export function PostHeader({
  frontmatter,
  readingMinutes,
}: {
  frontmatter: BlogFrontmatter;
  readingMinutes: number;
}) {
  const showUpdated = Boolean(frontmatter.updated) && frontmatter.updated !== frontmatter.date;
  return (
    <header className="mb-6 font-arabic text-start">
      <ClusterChip cluster={frontmatter.cluster} />
      <h1 className="text-3xl leading-[1.4] font-bold text-gray-900 mt-2">{frontmatter.title}</h1>
      {frontmatter.description && (
        <p className="text-base text-gray-600 mt-2">{frontmatter.description}</p>
      )}
      <div className="text-sm text-gray-500 mt-4 flex flex-wrap gap-2 items-center">
        <span>فريق يتفرج</span>
        <Dot />
        <span>اتنشر {formatArabicDate(frontmatter.date)}</span>
        {showUpdated && (
          <>
            <Dot />
            <span>اتحدّث {formatArabicDate(frontmatter.updated as string)}</span>
          </>
        )}
        <Dot />
        <span className="inline-flex items-center gap-1">
          <Clock className="h-4 w-4" aria-hidden="true" />
          {readingTimeLabel(readingMinutes)}
        </span>
      </div>
    </header>
  );
}

export default PostHeader;
